import sha256 from "crypto-js/sha256";


export function getHashedString(textMessage: string): string {
  const hashDigest = sha256(textMessage);
  return hashDigest.toString();
}
